import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/warpLogoSmall.png'
import _imports_1 from '@/assets/img/miniViewblock.png'
import _imports_2 from '@/assets/img/arweaveSmall.png'
import _imports_3 from '@/assets/img/redstoneSmall.png'


const _withScopeId = n => (_pushScopeId("data-v-30155a30"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arcode-main-toolbar-panel-title" }, " Arweave Explorer ", -1))
const _hoisted_2 = { class: "search-container" }
const _hoisted_3 = { class: "form-input" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Network", -1))
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "form-input" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Search Method", -1))
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "tx" }, "Search by Tx Id", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "address" }, "Search by Address", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "advanced" }, "Advanced Search", -1))
const _hoisted_13 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "form-input" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "TX ID", -1))
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "text-right" }
const _hoisted_18 = { class: "search-menu" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Search", -1))
const _hoisted_21 = { class: "form-input" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "From Address", -1))
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "text-right" }
const _hoisted_25 = { class: "form-radio" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Results filter", -1))
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["disabled"]
const _hoisted_29 = ["disabled"]
const _hoisted_30 = ["disabled"]
const _hoisted_31 = ["disabled"]
const _hoisted_32 = ["disabled"]
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { class: "form-radio" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Sorting order", -1))
const _hoisted_36 = ["disabled"]
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { class: "form-input" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Results limit", -1))
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { class: "search-menu" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Search", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "title-tags" }, "Tags", -1))
const _hoisted_45 = {
  key: 0,
  class: "no-results"
}
const _hoisted_46 = { class: "form-input col-key" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Name", -1))
const _hoisted_48 = ["disabled", "onUpdate:modelValue"]
const _hoisted_49 = { class: "form-input col-value" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Value", -1))
const _hoisted_51 = ["disabled", "onUpdate:modelValue"]
const _hoisted_52 = { class: "form-input col-action" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "title-tags" }, "From list", -1))
const _hoisted_54 = {
  key: 1,
  class: "no-results"
}
const _hoisted_55 = { class: "form-input col-address" }
const _hoisted_56 = ["disabled", "onUpdate:modelValue"]
const _hoisted_57 = { class: "form-input col-action" }
const _hoisted_58 = { class: "form-radio" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Sorting order", -1))
const _hoisted_60 = ["disabled"]
const _hoisted_61 = ["disabled"]
const _hoisted_62 = { class: "form-input" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Results limit", -1))
const _hoisted_64 = ["disabled"]
const _hoisted_65 = { class: "search-menu" }
const _hoisted_66 = ["disabled"]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add Tag", -1))
const _hoisted_68 = ["disabled"]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add Owner", -1))
const _hoisted_70 = ["disabled"]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Search", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Results:", -1))
const _hoisted_73 = {
  key: 0,
  class: "link-container text-left"
}
const _hoisted_74 = { key: 0 }
const _hoisted_75 = ["href"]
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Open in SonAR", -1))
const _hoisted_78 = [
  _hoisted_76,
  _hoisted_77
]
const _hoisted_79 = ["href"]
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Open in Viewblock", -1))
const _hoisted_82 = [
  _hoisted_80,
  _hoisted_81
]
const _hoisted_83 = ["href"]
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "invert-colors",
  src: _imports_2
}, null, -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Open in Arweave", -1))
const _hoisted_86 = [
  _hoisted_84,
  _hoisted_85
]
const _hoisted_87 = { key: 1 }
const _hoisted_88 = ["href"]
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "invert-colors",
  src: _imports_2
}, null, -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Open in ArCode Studio", -1))
const _hoisted_91 = [
  _hoisted_89,
  _hoisted_90
]
const _hoisted_92 = { class: "table" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"20%"} }, " Key "),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"80%"} }, " Value ")
  ])
], -1))
const _hoisted_94 = { style: {"width":"20%"} }
const _hoisted_95 = { style: {"width":"80%"} }
const _hoisted_96 = { class: "small-txt" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_98 = {
  key: 0,
  class: "small-txt"
}
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Block Height: ", -1))
const _hoisted_100 = {
  key: 1,
  class: "link-container text-left"
}
const _hoisted_101 = { key: 0 }
const _hoisted_102 = ["href"]
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Open in SonAR", -1))
const _hoisted_105 = [
  _hoisted_103,
  _hoisted_104
]
const _hoisted_106 = ["href"]
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Open in Viewblock", -1))
const _hoisted_109 = [
  _hoisted_107,
  _hoisted_108
]
const _hoisted_110 = ["href"]
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "invert-colors",
  src: _imports_2
}, null, -1))
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Open in Arweave", -1))
const _hoisted_113 = [
  _hoisted_111,
  _hoisted_112
]
const _hoisted_114 = { key: 1 }
const _hoisted_115 = ["href"]
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "invert-colors",
  src: _imports_2
}, null, -1))
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Open in ArCode Studio", -1))
const _hoisted_118 = [
  _hoisted_116,
  _hoisted_117
]
const _hoisted_119 = {
  key: 2,
  class: "link-container text-left"
}
const _hoisted_120 = { key: 0 }
const _hoisted_121 = ["href"]
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Open in SonAR", -1))
const _hoisted_124 = [
  _hoisted_122,
  _hoisted_123
]
const _hoisted_125 = { key: 1 }
const _hoisted_126 = ["href"]
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "invert-colors",
  src: _imports_2
}, null, -1))
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Open in ArCode Studio", -1))
const _hoisted_129 = [
  _hoisted_127,
  _hoisted_128
]
const _hoisted_130 = ["href"]
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Open in Testnet Redstone Tools Gateway", -1))
const _hoisted_133 = [
  _hoisted_131,
  _hoisted_132
]
const _hoisted_134 = ["onClick"]
const _hoisted_135 = {
  key: 3,
  class: "table"
}
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, " Key "),
    /*#__PURE__*/_createElementVNode("th", null, " Value ")
  ])
], -1))
const _hoisted_137 = { style: {"width":"20%"} }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_139 = {
  key: 0,
  class: "no-results text-center"
}
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lds-ring lds-ring-small" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Loading ...", -1))
const _hoisted_142 = [
  _hoisted_140,
  _hoisted_141
]
const _hoisted_143 = { class: "text-center" }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Load next results", -1))
const _hoisted_145 = [
  _hoisted_144
]
const _hoisted_146 = { class: "small-txt" }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_148 = {
  key: 0,
  class: "small-txt"
}
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Block Height: ", -1))
const _hoisted_150 = {
  key: 1,
  class: "link-container text-left"
}
const _hoisted_151 = { key: 0 }
const _hoisted_152 = ["href"]
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Open in SonAR", -1))
const _hoisted_155 = [
  _hoisted_153,
  _hoisted_154
]
const _hoisted_156 = ["href"]
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Open in Viewblock", -1))
const _hoisted_159 = [
  _hoisted_157,
  _hoisted_158
]
const _hoisted_160 = ["href"]
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "invert-colors",
  src: _imports_2
}, null, -1))
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Open in Arweave", -1))
const _hoisted_163 = [
  _hoisted_161,
  _hoisted_162
]
const _hoisted_164 = { key: 1 }
const _hoisted_165 = ["href"]
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "invert-colors",
  src: _imports_2
}, null, -1))
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Open in ArCode Studio", -1))
const _hoisted_168 = [
  _hoisted_166,
  _hoisted_167
]
const _hoisted_169 = {
  key: 2,
  class: "link-container text-left"
}
const _hoisted_170 = { key: 0 }
const _hoisted_171 = ["href"]
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Open in SonAR", -1))
const _hoisted_174 = [
  _hoisted_172,
  _hoisted_173
]
const _hoisted_175 = ["href"]
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Open in Testnet Redstone Tools Gateway", -1))
const _hoisted_178 = [
  _hoisted_176,
  _hoisted_177
]
const _hoisted_179 = ["onClick"]
const _hoisted_180 = {
  key: 3,
  class: "table"
}
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, " Key "),
    /*#__PURE__*/_createElementVNode("th", null, " Value ")
  ])
], -1))
const _hoisted_182 = { style: {"width":"20%"} }
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_184 = { class: "text-center" }
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Load next results", -1))
const _hoisted_186 = [
  _hoisted_185
]
const _hoisted_187 = {
  key: 6,
  class: "no-results"
}
const _hoisted_188 = {
  key: 7,
  class: "no-results text-center"
}
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lds-ring lds-ring-small" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Loading ...", -1))
const _hoisted_191 = [
  _hoisted_189,
  _hoisted_190
]

import {ref, computed, reactive} from 'vue';
import DefaultIcon from '@/components/atomic/DefaultIcon';
import { 
	ArweaveWrapper, arweaveNetworks,onMainnetByString,
	onTestnetByString, defaultNetwork } from '@/core/ArweaveWrapper';
import { ArDBWrapper, ArDBTag } from '@/core/ArDBWrapper';
import { createToast } from 'mosha-vue-toastify';

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchArweave',
  props: {
	mainAddress: String,
	login: Object,
	tx: String,
	networkParam: String
},
  setup(__props) {

const props = __props;



const txtTxId = ref('');
const txtAddress = ref('');
const txtResLimit = ref(10);
const txtResLimitAdvanced = ref(10);
const selSearchMethod = ref('tx');
const defaultSelNetwork = props.networkParam ? props.networkParam : defaultNetwork;
const selNetwork = ref(defaultSelNetwork);
const loadingSearch = ref(false);
const loadingMoreResults = ref(false);
const resultsTX = ref({});
const resultsTXIsContract = ref(false);
const resultsByAddress = ref([]);
const resultsByAddressMetadata = ref([]);
const advancedResults = ref([]);
const advancedResultsMetadata = ref([]);
const rdFilter = ref('');
const rdSortingOrderByAddress = ref('HEIGHT_DESC');
const rdSortingOrderAdvanced =  ref('HEIGHT_DESC');
const tagsList = reactive<Array<ArDBTag>>([]);
const ownersList = reactive<Array<{ owner: string }>>([]);
const mainAddress = ref(props.login.mainAddress);
const networks = computed(() => {
	return arweaveNetworks;
});
let gArDBWrapperSearchByAddress: ArDBWrapper|null = null;
let gArDBWrapperAdvancedSearch: ArDBWrapper|null = null;

const searchByTX = async (tx: string) => {
	if (!tx) {
		return;
	}
	resultsTX.value = {};
	resultsByAddress.value = [];
	resultsByAddressMetadata.value = [];
	advancedResults.value = [];
	advancedResultsMetadata.value = [];
	loadingSearch.value = true;
	resultsTXIsContract.value = false;
	try {
		const arweaveWrapper = new ArweaveWrapper(selNetwork.value);
		const arweave = arweaveWrapper.arweave;
		const ardbWrapper = new ArDBWrapper(arweave);
		const tmpRes = await ardbWrapper.findOneTx(tx);

		if (tmpRes) {
			resultsTX.value = tmpRes;
			resultsTX.value._tags.forEach(tag => {
				const key = tag.name ? tag.name : '';
				const value = tag.value ? tag.value : '';
				if (key == 'App-Name' && value == 'SmartWeaveContract') {
					resultsTXIsContract.value = true;
				}
			});
		}

	} catch (err) {
		console.error('searchByTx', err);
		const errorMsg = 'No results found.';
		createToast(`${errorMsg}`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      });
	}
	loadingSearch.value = false;
};

const searchByAddress = async (address: string, limit: number) => {
	limit = parseInt(limit);
	resultsByAddress.value = [];
	resultsByAddressMetadata.value = [];
	resultsTX.value = {};
	advancedResults.value = [];
	advancedResultsMetadata.value = [];
	loadingSearch.value = true;
	const sortOrder = rdSortingOrderByAddress.value;
	try {
		const tags: ArDBTag[] = [];
		const arweaveWrapper = new ArweaveWrapper(selNetwork.value);
		const arweave = arweaveWrapper.arweave;
		gArDBWrapperSearchByAddress = new ArDBWrapper(arweave);
		const ardbWrapper = gArDBWrapperSearchByAddress;

		if (!address) {
			// throw Error('');
			return;
		} else if (limit <= 0 || limit > 100) {
			throw Error('Limit must be between 1 - 100');
		}

		if (rdFilter.value === 'contracts') {
			tags.push({
        name: 'App-Name',
        values: ['SmartWeaveContract'],
      });
		} else if (rdFilter.value === 'contractSources') {
			tags.push({
        name: 'App-Name',
        values: ['SmartWeaveContractSource'],
      });
		} else if (rdFilter.value === 'nfts') {
			tags.push({
        name: 'App-Name',
        values: ['SmartWeaveContract'],
      });
      tags.push({
        name: 'Content-Type',
        values: [ 
					// Images
					'image/png', 'image/apng', 'image/avif',
					'image/gif', 'image/jpeg', 'image/svg+xml',
					'image/webp', 'image/jpg',
					// Audio and video
					'audio/wave', 'audio/wav', 'audio/x-wav',
					'audio/x-pn-wav', 'audio/webm',
					'video/webm', 'audio/ogg',
					'video/ogg', 'application/ogg',
					'video/mp4' ]
      });
		} else if (rdFilter.value === 'manifest') {
			tags.push({
        name: 'Type',
        values: ['manifest'],
      });
			tags.push({
        name: 'Content-Type',
        values: ['application/x.arweave-manifest+json'],
      });
		}
		else if (rdFilter.value === 'textFiles') {
			tags.push({
        name: 'Content-Type',
        values: [
					// Text Files
					'application/octet-stream', 'text/plain',
					'text/css', 'text/html', 'text/javascript',
        ],
      });
		} else if (rdFilter.value === 'mediaFiles') {
			tags.push({
        name: 'Content-Type',
        values: [
					// Images
					'image/png', 'image/apng', 'image/avif',
					'image/gif', 'image/jpeg', 'image/svg+xml',
					'image/webp', 'image/jpg',
					// Audio and video
					'audio/wave', 'audio/wav', 'audio/x-wav',
					'audio/x-pn-wav', 'audio/webm',
					'video/webm', 'audio/ogg',
					'video/ogg', 'application/ogg',
					'video/mp4'
        ],
      });
		}
		
		resultsByAddress.value = await ardbWrapper.findFromOwners(
			address, limit, tags, sortOrder
		);

		for (let i = 0; i < resultsByAddress.value.length; i++) {
			resultsByAddressMetadata.value.push({ visible: false });
		}

		
	} catch (err) {
		createToast(`${err}`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      });
	}
	loadingSearch.value = false;
};

const nextResultsSearchByAddress = async () => {
	const ardbWrapper = gArDBWrapperSearchByAddress;
	loadingMoreResults.value = true;
	try {
		const nextRes = await ardbWrapper.nextResults();
		if (nextRes && Object.prototype.hasOwnProperty.call(nextRes, 'length') &&
				nextRes.length) {
			resultsByAddress.value.push(...nextRes);

			for (let i = 0; i < nextRes.length; i++) {
				resultsByAddressMetadata.value.push({ visible: false });
			}

		} else if (nextRes && Object.prototype.hasOwnProperty.call(nextRes, 'length') &&
				nextRes.length === 0) {
			createToast(`No more results found.`,
      {
        type: 'warning',
        showIcon: true,
        position: 'bottom-right',
      });
		}else if (nextRes && Object.keys(nextRes)) {
			resultsByAddress.value.push(nextRes);
			resultsByAddressMetadata.value.push({ visible: false });
		} else {
			createToast(`No more results found.`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      });
		}
		loadingMoreResults.value = false;
	} catch (err) {
		createToast(`${err}`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      });
		loadingMoreResults.value = false;
	}
};

const txIsContract = (tags) => {
	let isContract = false;
	if (!tags) {
		return false;
	}
	tags.forEach(tag => {
		const key = tag.name ? tag.name : '';
		const value = tag.value ? tag.value : '';
		if (key == 'App-Name' && value == 'SmartWeaveContract') {
			isContract = true;
		}
	});
	return isContract;
}

const removeTag = (index: number, tags: Array<{name: string, values: string[]}>) => {
	tags.splice(index, 1);
};

const addTag = (key: string, values: string, tags: Array<{name: string, values: string[]}>) => {
	tags.push({ key, values });
};

const removeOwner = (index: number, owners: Array<{owner: string}>) => {
	owners.splice(index, 1);
};

const addOwner = (owner: string, owners: Array<{owner: string}>) => {
	owners.push({ owner });
};

const advancedSearch = async (
	tagsList: Array<ArDBTag>,
	ownersList: Array<{owner: string}>,
	limit: number) => {
	limit = parseInt(limit);
	resultsByAddress.value = [];
	resultsTX.value = {};
	advancedResults.value = [];
	advancedResultsMetadata.value = [];
	loadingSearch.value = true;
	const sortOrder = rdSortingOrderAdvanced.value;
	try {
		const tags: ArDBTag[] = [];
		const owners: string[] = [];
		const arweaveWrapper = new ArweaveWrapper(selNetwork.value);
		const arweave = arweaveWrapper.arweave;
		gArDBWrapperAdvancedSearch = new ArDBWrapper(arweave);
		const ardbWrapper = gArDBWrapperAdvancedSearch;

		if (!tagsList.length && !ownersList.length ) {
			throw Error('Please provide tags or an owner address');
		} else if (limit <= 0 || limit > 100) {
			throw Error('Limit must be between 1 - 100');
		}

		for (const t of tagsList) {
			const tname = t.name;
			const tvalues = t.values;
			if (!tname) {
				throw Error('Tags: Empty Key');
			}
			tags.push({
        name: tname,
        values: tvalues.split(','),
      });
		}

		for (const o of ownersList) {
			const owner = o.owner.trim();
			if (!owner) {
				throw Error('Empty owner');
			}
			owners.push(owner);
		}

		advancedResults.value = await ardbWrapper.findFromOwners(
			owners,
			limit,
			tags,
			sortOrder);

		for (let i = 0; i < advancedResults.value.length; i++) {
			advancedResultsMetadata.value.push({ visible: false });
		}

	} catch (err) {
		createToast(`${err}`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      });
	}
	loadingSearch.value = false;
};


const nextResultsAdvancedSearch = async () => {
	const ardbWrapper = gArDBWrapperAdvancedSearch;
	loadingMoreResults.value = true;
	try {
		const nextRes = await ardbWrapper.nextResults();
		if (nextRes && Object.prototype.hasOwnProperty.call(nextRes, 'length') &&
				nextRes.length) {
			advancedResults.value.push(...nextRes);

			for (let i = 0; i < nextRes.length; i++) {
				advancedResultsMetadata.value.push({ visible: false });
			}
			
		} else if (nextRes && Object.prototype.hasOwnProperty.call(nextRes, 'length') &&
				nextRes.length === 0) {
			createToast(`No more results found.`,
      {
        type: 'warning',
        showIcon: true,
        position: 'bottom-right',
      });
		}else if (nextRes && Object.keys(nextRes)) {
			advancedResults.value.push(nextRes);
			advancedResultsMetadata.value.push({ visible: false });
		} else {
			createToast(`No more results found.`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      });
		}
		loadingMoreResults.value = false;
	} catch (err) {
		createToast(`${err}`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      });
		loadingMoreResults.value = false;
	}
};

const isMainnet = computed(() => {
	return onMainnetByString(selNetwork.value);
});

const isTestnet = computed(() => {
	return onTestnetByString(selNetwork.value);
});

const resetResults = () => {
	loadingMoreResults.value = false;
	resultsTX.value = {};
	resultsByAddress.value = [];
	resultsByAddressMetadata.value = [];
	advancedResults.value = [];
	advancedResultsMetadata.value = [];
	loadingSearch.value = false;
	resultsTXIsContract.value = false;
	txtTxId.value = '';
	txtAddress.value = '';
	rdFilter.value = '';
	rdSortingOrderByAddress.value = 'HEIGHT_DESC';
	txtResLimit.value = 10;
	// Advanced
	while (tagsList.length) {
		tagsList.pop();
	}
	while (ownersList.length) {
		ownersList.pop();
	}
	rdSortingOrderAdvanced.value = 'HEIGHT_DESC';
	txtResLimitAdvanced.value = 10;
}

const timestampFormat = (d: number|string) => {
  if (!d) {
    return '';
  }
  const prev = new Date(+d * 1000);
  const current = new Date();
  const millisecondsEllapsed = current.getTime() - prev.getTime(); 
  const seconds = Math.floor(millisecondsEllapsed / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  if (days) {
    const month = months[prev.getMonth()];
    const date = prev.getDate();
    const year = prev.getFullYear();
    const currentYear = current.getFullYear();
    if (currentYear === year) {
      return `${month} ${date}`;
    }
    return `${month} ${date}, ${year}`;
  } else if (hours) {
    return `${hours}h`;
  } else if (minutes) {
    return `${minutes}m`;
  } else if (seconds) {
    return `${seconds}s`;
  }


  return ``;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("select", {
          onChange: _cache[0] || (_cache[0] = ($event: any) => (resetResults())),
          disabled: loadingSearch.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selNetwork).value = $event))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(networks), (nItem, nIndex) => {
            return (_openBlock(), _createElementBlock("option", {
              key: nIndex,
              value: nIndex
            }, _toDisplayString(nItem.host) + " (" + _toDisplayString(nIndex) + ")", 9, _hoisted_6))
          }), 128))
        ], 40, _hoisted_5), [
          [
            _vModelSelect,
            selNetwork.value,
            void 0,
            { trim: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("select", {
          disabled: loadingSearch.value,
          onChange: _cache[2] || (_cache[2] = ($event: any) => (resetResults())),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selSearchMethod).value = $event))
        }, _hoisted_13, 40, _hoisted_9), [
          [
            _vModelSelect,
            selSearchMethod.value,
            void 0,
            { trim: true }
          ]
        ])
      ]),
      (selSearchMethod.value == 'tx')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _withDirectives(_createElementVNode("input", {
                disabled: loadingSearch.value,
                type: "text",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((txtTxId).value = $event)),
                onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (searchByTX(txtTxId.value)), ["enter"]))
              }, null, 40, _hoisted_16), [
                [
                  _vModelText,
                  txtTxId.value,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_17, [
                (__props.tx)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "link",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (txtTxId.value = __props.tx))
                    }, "Use TX from URL"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("ul", _hoisted_18, [
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  class: _normalizeClass({primary: (txtTxId.value) && !loadingSearch.value}),
                  disabled: (!txtTxId.value || !selSearchMethod.value) || loadingSearch.value,
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (searchByTX(txtTxId.value)))
                }, [
                  _createVNode(_unref(DefaultIcon), {
                    class: "icon-btn",
                    icon: "codicon-search"
                  }),
                  _hoisted_20
                ], 10, _hoisted_19)
              ])
            ])
          ], 64))
        : (selSearchMethod.value == 'address')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _withDirectives(_createElementVNode("input", {
                  disabled: loadingSearch.value,
                  type: "text",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((txtAddress).value = $event)),
                  onKeyup: _cache[9] || (_cache[9] = _withKeys(($event: any) => (searchByAddress(txtAddress.value, txtResLimit.value)), ["enter"]))
                }, null, 40, _hoisted_23), [
                  [
                    _vModelText,
                    txtAddress.value,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _createElementVNode("div", _hoisted_24, [
                  (mainAddress.value)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "link",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (txtAddress.value = mainAddress.value))
                      }, "Use my wallet address"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    disabled: loadingSearch.value,
                    checked: "",
                    name: "addressFilter",
                    value: "",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((rdFilter).value = $event))
                  }, null, 8, _hoisted_27), [
                    [
                      _vModelRadio,
                      rdFilter.value,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createTextVNode(" All TXs ")
                ]),
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    disabled: loadingSearch.value,
                    type: "radio",
                    name: "addressFilter",
                    value: "contracts",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((rdFilter).value = $event))
                  }, null, 8, _hoisted_28), [
                    [
                      _vModelRadio,
                      rdFilter.value,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createTextVNode(" Smart Contracts ")
                ]),
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    disabled: loadingSearch.value,
                    type: "radio",
                    name: "addressFilter",
                    value: "contractSources",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((rdFilter).value = $event))
                  }, null, 8, _hoisted_29), [
                    [
                      _vModelRadio,
                      rdFilter.value,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createTextVNode(" Contract Sources ")
                ]),
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    disabled: loadingSearch.value,
                    type: "radio",
                    name: "addressFilter",
                    value: "nfts",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((rdFilter).value = $event))
                  }, null, 8, _hoisted_30), [
                    [
                      _vModelRadio,
                      rdFilter.value,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createTextVNode(" NFT Atomic Assets ")
                ]),
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    disabled: loadingSearch.value,
                    type: "radio",
                    name: "addressFilter",
                    value: "manifest",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((rdFilter).value = $event))
                  }, null, 8, _hoisted_31), [
                    [
                      _vModelRadio,
                      rdFilter.value,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createTextVNode(" Manifest Files ")
                ]),
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    disabled: loadingSearch.value,
                    type: "radio",
                    name: "addressFilter",
                    value: "textFiles",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((rdFilter).value = $event))
                  }, null, 8, _hoisted_32), [
                    [
                      _vModelRadio,
                      rdFilter.value,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createTextVNode(" Text Files ")
                ]),
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    disabled: loadingSearch.value,
                    type: "radio",
                    name: "addressFilter",
                    value: "mediaFiles",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((rdFilter).value = $event))
                  }, null, 8, _hoisted_33), [
                    [
                      _vModelRadio,
                      rdFilter.value,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createTextVNode(" Media Files ")
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    disabled: loadingSearch.value,
                    name: "sortingOrderByAddress",
                    value: "HEIGHT_ASC",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((rdSortingOrderByAddress).value = $event))
                  }, null, 8, _hoisted_36), [
                    [
                      _vModelRadio,
                      rdSortingOrderByAddress.value,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createTextVNode(" Height Ascending ")
                ]),
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    disabled: loadingSearch.value,
                    name: "sortingOrderByAddress",
                    value: "HEIGHT_DESC",
                    checked: "",
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((rdSortingOrderByAddress).value = $event))
                  }, null, 8, _hoisted_37), [
                    [
                      _vModelRadio,
                      rdSortingOrderByAddress.value,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createTextVNode(" Height Descending ")
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  max: "100",
                  min: "1",
                  disabled: loadingSearch.value,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((txtResLimit).value = $event)),
                  onKeyup: _cache[21] || (_cache[21] = _withKeys(($event: any) => (searchByAddress(txtAddress.value, txtResLimit.value)), ["enter"]))
                }, null, 40, _hoisted_40), [
                  [
                    _vModelText,
                    txtResLimit.value,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createElementVNode("ul", _hoisted_41, [
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: _normalizeClass({primary: (txtAddress.value && txtResLimit.value) && !loadingSearch.value}),
                    disabled: (!txtAddress.value || !selSearchMethod.value || !txtResLimit.value) || loadingSearch.value,
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (searchByAddress(txtAddress.value, txtResLimit.value)))
                  }, [
                    _createVNode(_unref(DefaultIcon), {
                      class: "icon-btn",
                      icon: "codicon-search"
                    }),
                    _hoisted_43
                  ], 10, _hoisted_42)
                ])
              ])
            ], 64))
          : _createCommentVNode("", true),
      (selSearchMethod.value == 'advanced')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _hoisted_44,
            (!tagsList.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_45, "No tags."))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagsList, (tL1, index1) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "data-input-list",
                key: index1
              }, [
                _createElementVNode("div", _hoisted_46, [
                  _hoisted_47,
                  _withDirectives(_createElementVNode("input", {
                    disabled: loadingSearch.value,
                    type: "text",
                    "onUpdate:modelValue": ($event: any) => ((tL1.name) = $event)
                  }, null, 8, _hoisted_48), [
                    [
                      _vModelText,
                      tL1.name,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _withDirectives(_createElementVNode("input", {
                    disabled: loadingSearch.value,
                    type: "text",
                    "onUpdate:modelValue": ($event: any) => ((tL1.values) = $event)
                  }, null, 8, _hoisted_51), [
                    [
                      _vModelText,
                      tL1.values,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createVNode(_unref(DefaultIcon), {
                    onClick: ($event: any) => (removeTag(index1, tagsList)),
                    class: "icon-action",
                    icon: "codicon-trash"
                  }, null, 8, ["onClick"])
                ])
              ]))
            }), 128)),
            _hoisted_53,
            (!ownersList.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_54, "No owners."))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ownersList, (fL1, index1) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "data-input-list",
                key: index1
              }, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("label", null, "Wallet address #" + _toDisplayString(index1 + 1), 1),
                  _withDirectives(_createElementVNode("input", {
                    disabled: loadingSearch.value,
                    type: "text",
                    "onUpdate:modelValue": ($event: any) => ((fL1.owner) = $event)
                  }, null, 8, _hoisted_56), [
                    [
                      _vModelText,
                      fL1.owner,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createVNode(_unref(DefaultIcon), {
                    onClick: ($event: any) => (removeOwner(index1, ownersList)),
                    class: "icon-action",
                    icon: "codicon-trash"
                  }, null, 8, ["onClick"])
                ])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_58, [
              _hoisted_59,
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  disabled: loadingSearch.value,
                  name: "sortingOrderAdvanced",
                  value: "HEIGHT_ASC",
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((rdSortingOrderAdvanced).value = $event))
                }, null, 8, _hoisted_60), [
                  [
                    _vModelRadio,
                    rdSortingOrderAdvanced.value,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _createTextVNode(" Height Ascending ")
              ]),
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  disabled: loadingSearch.value,
                  name: "sortingOrderAdvanced",
                  value: "HEIGHT_DESC",
                  checked: "",
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((rdSortingOrderAdvanced).value = $event))
                }, null, 8, _hoisted_61), [
                  [
                    _vModelRadio,
                    rdSortingOrderAdvanced.value,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _createTextVNode(" Height Descending ")
              ])
            ]),
            _createElementVNode("div", _hoisted_62, [
              _hoisted_63,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                max: "100",
                min: "1",
                maxlength: "3",
                disabled: loadingSearch.value,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((txtResLimitAdvanced).value = $event)),
                onKeyup: _cache[26] || (_cache[26] = _withKeys(($event: any) => (advancedSearch(tagsList, ownersList, txtResLimitAdvanced.value)), ["enter"]))
              }, null, 40, _hoisted_64), [
                [
                  _vModelText,
                  txtResLimitAdvanced.value,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("ul", _hoisted_65, [
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  class: _normalizeClass({primary: !loadingSearch.value}),
                  disabled: loadingSearch.value,
                  onClick: _cache[27] || (_cache[27] = ($event: any) => (addTag('', '', tagsList)))
                }, [
                  _createVNode(_unref(DefaultIcon), {
                    class: "icon-btn",
                    icon: "codicon-tag"
                  }),
                  _hoisted_67
                ], 10, _hoisted_66)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  class: _normalizeClass({primary: !loadingSearch.value}),
                  disabled: loadingSearch.value,
                  onClick: _cache[28] || (_cache[28] = ($event: any) => (addOwner('', ownersList)))
                }, [
                  _createVNode(_unref(DefaultIcon), {
                    class: "icon-btn",
                    icon: "codicon-account"
                  }),
                  _hoisted_69
                ], 10, _hoisted_68)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  class: _normalizeClass({primary: (tagsList.length || ownersList.length) && !loadingSearch.value}),
                  disabled: (!tagsList.length && !ownersList.length) || loadingSearch.value,
                  onClick: _cache[29] || (_cache[29] = ($event: any) => (advancedSearch(tagsList, ownersList, txtResLimitAdvanced.value)))
                }, [
                  _createVNode(_unref(DefaultIcon), {
                    class: "icon-btn",
                    icon: "codicon-search"
                  }),
                  _hoisted_71
                ], 10, _hoisted_70)
              ])
            ])
          ], 64))
        : _createCommentVNode("", true),
      _hoisted_72,
      (resultsTX.value && Object.keys(resultsTX.value).length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            (_unref(isMainnet))
              ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                  (resultsTXIsContract.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_74, [
                        _createElementVNode("a", {
                          href: `https://sonar.warp.cc/#/app/contract/${txtTxId.value}`,
                          target: "_blank"
                        }, _hoisted_78, 8, _hoisted_75)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", null, [
                    _createElementVNode("a", {
                      href: `https://viewblock.io/arweave/tx/${txtTxId.value}`,
                      target: "_blank"
                    }, _hoisted_82, 8, _hoisted_79)
                  ]),
                  _createElementVNode("p", null, [
                    _createElementVNode("a", {
                      href: `https://arweave.net/${txtTxId.value}`,
                      target: "_blank"
                    }, _hoisted_86, 8, _hoisted_83)
                  ]),
                  (resultsTXIsContract.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_87, [
                        _createElementVNode("a", {
                          href: `https://arcode.studio/#/${txtTxId.value}`,
                          target: "_blank"
                        }, _hoisted_91, 8, _hoisted_88)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("table", _hoisted_92, [
              _hoisted_93,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(resultsTX.value), (k) => {
                  return (_openBlock(), _createElementBlock("tr", { key: k }, [
                    _createElementVNode("td", _hoisted_94, _toDisplayString(k), 1),
                    _createElementVNode("td", _hoisted_95, [
                      _createElementVNode("pre", null, _toDisplayString(resultsTX.value[k]), 1)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ], 64))
        : _createCommentVNode("", true),
      (resultsByAddress.value && resultsByAddress.value.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultsByAddress.value, (r, rAIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: r._id
              }, [
                _createElementVNode("p", _hoisted_96, [
                  _createElementVNode("strong", null, "TX " + _toDisplayString(rAIndex + 1) + ":", 1),
                  _hoisted_97,
                  _createElementVNode("span", null, _toDisplayString(r._id), 1)
                ]),
                (r._block && r._block.height && r._block.timestamp)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_98, [
                      _hoisted_99,
                      _createElementVNode("span", null, _toDisplayString(r._block.height) + " (" + _toDisplayString(timestampFormat(r._block.timestamp)) + ") ", 1)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isMainnet))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                      (txIsContract(r._tags))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_101, [
                            _createElementVNode("a", {
                              href: `https://sonar.warp.cc/#/app/contract/${r._id}`,
                              target: "_blank"
                            }, _hoisted_105, 8, _hoisted_102)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", null, [
                        _createElementVNode("a", {
                          href: `https://viewblock.io/arweave/tx/${r._id}`,
                          target: "_blank"
                        }, _hoisted_109, 8, _hoisted_106)
                      ]),
                      _createElementVNode("p", null, [
                        _createElementVNode("a", {
                          href: `https://arweave.net/${r._id}`,
                          target: "_blank"
                        }, _hoisted_113, 8, _hoisted_110)
                      ]),
                      (txIsContract(r._tags))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_114, [
                            _createElementVNode("a", {
                              href: `https://arcode.studio/#/${r._id}`,
                              target: "_blank"
                            }, _hoisted_118, 8, _hoisted_115)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isTestnet))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                      (txIsContract(r._tags))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_120, [
                            _createElementVNode("a", {
                              href: `https://sonar.warp.cc/#/app/contract/${r._id}?network=testnet`,
                              target: "_blank"
                            }, _hoisted_124, 8, _hoisted_121)
                          ]))
                        : _createCommentVNode("", true),
                      (txIsContract(r._tags))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_125, [
                            _createElementVNode("a", {
                              href: `https://arcode.studio/#/${r._id}?network=redstone-testnet`,
                              target: "_blank"
                            }, _hoisted_129, 8, _hoisted_126)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", null, [
                        _createElementVNode("a", {
                          href: `https://testnet.redstone.tools/${r._id}`,
                          target: "_blank"
                        }, _hoisted_133, 8, _hoisted_130)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  onClick: ($event: any) => (resultsByAddressMetadata.value[rAIndex].visible = !resultsByAddressMetadata.value[rAIndex].visible),
                  class: "show-details-link"
                }, [
                  _createElementVNode("span", null, _toDisplayString(!resultsByAddressMetadata.value[rAIndex].visible ? '+ Show' : '- Hide'), 1),
                  _createTextVNode(" full details ")
                ], 8, _hoisted_134),
                (resultsByAddressMetadata.value[rAIndex].visible)
                  ? (_openBlock(), _createElementBlock("table", _hoisted_135, [
                      _hoisted_136,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(r), (k) => {
                          return (_openBlock(), _createElementBlock("tr", { key: k }, [
                            _createElementVNode("td", _hoisted_137, _toDisplayString(k), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("pre", null, _toDisplayString(r[k]), 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_138
              ]))
            }), 128)),
            (loadingMoreResults.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_139, _hoisted_142))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_143, [
              (selSearchMethod.value == 'address' && !loadingMoreResults.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "more-results-btn primary",
                    onClick: _cache[30] || (_cache[30] = ($event: any) => (nextResultsSearchByAddress()))
                  }, _hoisted_145))
                : _createCommentVNode("", true)
            ])
          ], 64))
        : _createCommentVNode("", true),
      (advancedResults.value && advancedResults.value.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(advancedResults.value, (r, rIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: r._id
              }, [
                _createElementVNode("p", _hoisted_146, [
                  _createElementVNode("strong", null, "TX " + _toDisplayString(rIndex + 1) + ":", 1),
                  _hoisted_147,
                  _createElementVNode("span", null, _toDisplayString(r._id), 1)
                ]),
                (r._block && r._block.height && r._block.timestamp)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_148, [
                      _hoisted_149,
                      _createElementVNode("span", null, _toDisplayString(r._block.height) + " (" + _toDisplayString(timestampFormat(r._block.timestamp)) + ") ", 1)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isMainnet))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
                      (txIsContract(r._tags))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_151, [
                            _createElementVNode("a", {
                              href: `https://sonar.warp.cc/#/app/contract/${r._id}`,
                              target: "_blank"
                            }, _hoisted_155, 8, _hoisted_152)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", null, [
                        _createElementVNode("a", {
                          href: `https://viewblock.io/arweave/tx/${r._id}`,
                          target: "_blank"
                        }, _hoisted_159, 8, _hoisted_156)
                      ]),
                      _createElementVNode("p", null, [
                        _createElementVNode("a", {
                          href: `https://arweave.net/${r._id}`,
                          target: "_blank"
                        }, _hoisted_163, 8, _hoisted_160)
                      ]),
                      (txIsContract(r._tags))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_164, [
                            _createElementVNode("a", {
                              href: `https://arcode.studio/#/${r._id}`,
                              target: "_blank"
                            }, _hoisted_168, 8, _hoisted_165)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isTestnet))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_169, [
                      (txIsContract(r._tags))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_170, [
                            _createElementVNode("a", {
                              href: `https://sonar.warp.cc/#/app/contract/${r._id}?network=testnet`,
                              target: "_blank"
                            }, _hoisted_174, 8, _hoisted_171)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", null, [
                        _createElementVNode("a", {
                          href: `https://testnet.redstone.tools/${r._id}`,
                          target: "_blank"
                        }, _hoisted_178, 8, _hoisted_175)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  onClick: ($event: any) => (advancedResultsMetadata.value[rIndex].visible = !advancedResultsMetadata.value[rIndex].visible),
                  class: "show-details-link"
                }, [
                  _createElementVNode("span", null, _toDisplayString(!advancedResultsMetadata.value[rIndex].visible ? '+ Show' : '- Hide'), 1),
                  _createTextVNode(" full details ")
                ], 8, _hoisted_179),
                (advancedResultsMetadata.value[rIndex].visible)
                  ? (_openBlock(), _createElementBlock("table", _hoisted_180, [
                      _hoisted_181,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(r), (k) => {
                          return (_openBlock(), _createElementBlock("tr", { key: k }, [
                            _createElementVNode("td", _hoisted_182, _toDisplayString(k), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("pre", null, _toDisplayString(r[k]), 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_183
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_184, [
              (selSearchMethod.value == 'advanced' && !loadingMoreResults.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "more-results-btn primary",
                    onClick: _cache[31] || (_cache[31] = ($event: any) => (nextResultsAdvancedSearch()))
                  }, _hoisted_186))
                : _createCommentVNode("", true)
            ])
          ], 64))
        : _createCommentVNode("", true),
      ((!resultsTX.value || Object.keys(resultsTX.value).length <= 0) && 
					(!resultsByAddress.value || resultsByAddress.value.length <= 0) && 
					(!advancedResults.value || advancedResults.value.length <= 0) && 
					!loadingSearch.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_187, " No results. "))
        : _createCommentVNode("", true),
      (loadingSearch.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_188, _hoisted_191))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})